module.exports = __webpack_public_path__ + "img/lightening-gold.5505c43e.svg";